import { PageRulesTab, Translation } from '@enums';
import i18n from '@translations';
import type { TabItem } from '@types';

export const getPageRulesTabs = (): TabItem[] =>
  [
    {
      key: PageRulesTab.PAGE_RULES,
      name: i18n.t(`${Translation.Configuration}:tabs.pageRules.pageRules`),
    },
  ] as const;
